import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ErrorMessage } from 'app/core/error-handler/constants';
import { Error } from 'app/core/error-handler/models';
import { createErrorRaised } from 'app/core/error-handler/state/actions';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FeatureInterface } from '../models';
import { FeatureControlRestConnectorService } from '../services';

import {
  FeatureControlActionType,
  LoadFeaturesCompleted,
} from './actions';

@Injectable()
export class FeatureControlEffects {
  public source: string = 'FeatureControlEffects';

  constructor(
    private readonly _actions$: Actions,
    private readonly _featureConnector: FeatureControlRestConnectorService
  ) {}

  @Effect()
  public loadFeatures$: Observable<Action> = this._actions$.pipe(
    ofType(FeatureControlActionType.LoadFeatures),
    switchMap(() => {
      return this._featureConnector.loadFeatures().pipe(
        map(
          (features: FeatureInterface[]) => new LoadFeaturesCompleted(features)
        ),
        catchError((err: any) =>
          of(
            createErrorRaised(
              new Error({
                message: ErrorMessage.unexpected,
                errorResponse: err,
                source: this.source,
              })
            )
          )
        )
      );
    })
  );
}
